/*
 * DRIVLY-UI React Components
 * @license MIT
 */
import*as e from"react";import{useSyncExternalStore as t}from"./useSyncExternalStoreShimClient.js";import{useSyncExternalStore as n}from"./useSyncExternalStoreShimServer.js";const r=!("undefined"!=typeof window&&void 0!==window.document&&void 0!==window.document.createElement)?n:t,o="useSyncExternalStore"in e?e.useSyncExternalStore:r;export{o as useSyncExternalStore};
//# sourceMappingURL=index.js.map
